import { render, staticRenderFns } from "./CreateOrRecover.vue?vue&type=template&id=741fb130&scoped=true"
import script from "./CreateOrRecover.vue?vue&type=script&lang=js"
export * from "./CreateOrRecover.vue?vue&type=script&lang=js"
import style0 from "./CreateOrRecover.vue?vue&type=style&index=0&id=741fb130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741fb130",
  null
  
)

export default component.exports